import { EMPTY_LIST } from '../../../../../constants/common'
import { getItemsFromApiResponse } from '../../../../../utils/api'
import { getRecipientRealId } from '../../../../../utils/email'
import {
  expandRecipientEmailsForTo,
  getRecipientsWithExpandedEmails,
  toEmailRecipientFieldSelectItemsFromOption,
} from '../../../EmailRecipientsField'
import { isEmailCreationFormAutoAddAdditionalContactsEnabled } from '../../EmailCreationForm.utils'

function buildFetchedById(fetchedItems) {
  const map = new Map()

  fetchedItems.forEach(fetched => {
    const realId = getRecipientRealId(fetched)

    if (realId !== null && !map.has(realId)) {
      map.set(realId, fetched)
    }
  })

  return map
}

export function getInitialEnabled(disabled) {
  if (disabled) {
    return false
  }

  return isEmailCreationFormAutoAddAdditionalContactsEnabled()
}

// Replace the cached `emails` array on each stored item with the fresh
// expanded array, so expandRecipientEmailsForTo sees correct source data and
// subsequent toggles can use the cached emails instead of refetching. Returns
// the same array reference when nothing was actually merged, so the caller
// can detect change via `!==`.
export function mergeExpandedEmails(workingTo, fetchedById) {
  const next = workingTo.map(item => {
    const realId = getRecipientRealId(item)
    const fetched = realId !== null ? fetchedById.get(realId) : null

    if (!fetched || !Array.isArray(fetched.emails)) {
      return item
    }

    return { ...item, emails: fetched.emails }
  })

  return next.some((item, i) => item !== workingTo[i]) ? next : workingTo
}

export async function fetchAndExpand(state) {
  const response = await getRecipientsWithExpandedEmails(state.idsNeedingFetch)

  const fetchedItems = toEmailRecipientFieldSelectItemsFromOption(
    getItemsFromApiResponse(response) || EMPTY_LIST
  )
  const fetchedById = buildFetchedById(fetchedItems)

  const mergedTo = mergeExpandedEmails(state.workingTo, fetchedById)

  return state.idsNeedingFetch.reduce(
    (acc, id) => {
      const fetched = fetchedById.get(id)

      if (!fetched) {
        return acc
      }

      const hasFetchedAdditional =
        Array.isArray(fetched.emails) && fetched.emails.length > 1
      const additions = expandRecipientEmailsForTo(acc.workingTo, fetched)

      return {
        ...acc,
        hasAdditional: acc.hasAdditional || hasFetchedAdditional,
        workingTo:
          additions.length > 0
            ? [...acc.workingTo, ...additions]
            : acc.workingTo,
      }
    },
    { ...state, workingTo: mergedTo }
  )
}
